import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductBrandService } from '../../../services/product-brand.service';

@Component({
  selector: 'app-view-product-brands',
  templateUrl: './view-product-brands.component.html',
  styleUrls: ['./view-product-brands.component.css'],
  providers:[ProductBrandService]
})
export class ViewProductBrandsComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productBrand: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productBrandService:ProductBrandService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductBrand();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductBrand(){
    this.productBrandService.get(this.id).subscribe((productBrand) => {
      this.productBrand = productBrand;
    });
  }
  

  saveProductBrand(){
    this.parseProductsType();
    if (this.productBrand.id == undefined){
      this.productBrandService.create(this.returnProductBrandProperties(this.productBrand))
      .subscribe((productBrand) => {
        this.productBrandService.get(productBrand.id).subscribe((productBrand) => {
          this.productBrand = productBrand;
          this.router.navigate(['/configuration/productbrands']);
        });
      });
    }else{
      this.productBrandService.update(this.returnProductBrandProperties(this.productBrand))
      .subscribe((productBrand) => {
        this.productBrand = productBrand;
      });
    }
  }

  returnProductBrandProperties(productBrand){
    var properties = {
      name: productBrand.name,
      product_types: productBrand.product_types
    }
    if (productBrand.id){
      properties['id'] = productBrand.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productBrand.product_types = "";
    if(this.productBrand.mobiles === true){
      this.productBrand.product_types += "1,";
    }
    if(this.productBrand.consoles === true){
      this.productBrand.product_types += "2,";
    }
    if(this.productBrand.products === true){
      this.productBrand.product_types += "3,";
    }
    if(this.productBrand.laptops === true){
      this.productBrand.product_types += "4,";
    }
    this.productBrand.product_types = this.productBrand.product_types.substring(0,this.productBrand.product_types.length - 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-brands/view-product-brands/view-product-brands.component.ts